import { Box, Typography } from "@mui/material";
import {
  HandleStatus,
  ProcedureName,
  Status,
} from "../../../assets/data/Constants";
import { TkGetCode } from "../../../utils/TkGetCode";
import { Link } from "react-router-dom";
import TkButton from "../../../components/atoms/TkButton";
import { ITkFakeTableLineProps } from "../../../type/componentsType/TkFakeTableLine";
import TkModal from "../../../components/atoms/TkModal";
import TkTitle from "../../../components/atoms/TkTitle";
import TkFakeTable from "../../../components/molecules/TkFakeTable";
import TkTable from "../../../components/atoms/TkTable";
import { LatestProcedureInfoList } from "../../../type/apiType/IAPI_APP001";
import {
  IAPI_APP017_Response,
  ProcedureInfoList,
} from "../../../type/apiType/IAPI_APP017";

interface ITopInfoProps {
  item: IAPI_APP017_Response;
}
/**
 * 契約者・住所・担当者　表示
 * @param {IAPI_APP017_Response} props.item APIレスポンス
 * @return TopInfo
 */
const TopInfo: React.FC<ITopInfoProps> = (props) => {
  const { item } = props;

  return (
    <Box className="SCRC020001Components">
      <Box className="topInfo">
        <Typography>
          <span>契約者</span>　{item.contractorNo}:{item.corpName}
        </Typography>
        <Typography>
          <span>代行者</span>　{item.agentName}
        </Typography>
        <Typography>
          <span>代行者登録メールアドレス</span>　
          <Link to="/SCRC100003" state={{ userId: item.agentId }}>
            {item.agentEmail}
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

interface IHandleButtonProps {
  item: ProcedureInfoList | LatestProcedureInfoList; // 手続き情報リスト | 最近の手続き履歴リスト
  isHistory: boolean; // true: 最近の手続き履歴　false: 対応が必要な手続
  onClick: any; // ボタンクリックイベント
}
/**
 * 対応　ボタン
 * @param props.item APIレスポンス
 * @param onClick クリックイベント
 * @return HandleButton
 */
const HandleButton: React.FC<IHandleButtonProps> = (props) => {
  const { item, isHistory, onClick } = props;

  let buttonName;

  switch (item?.handleStatus) {
    case HandleStatus["未対応"]:
    case HandleStatus["手続中"]:
      if (!isHistory && item.businessType === "JOB-45") {
        buttonName = "確認";
      } else if (
        item.latestApplyStatus === Status["届出待ち"] &&
        item.applyId
      ) {
        buttonName = "手続きへ";
      } else if (
        item.latestApplyStatus === Status["契約者差戻し中"] &&
        item.applyId
      ) {
        buttonName = "手続きへ,取下";
      } else if (
        item.executionKbn === "2" ||
        item.executionKbn === "3" ||
        item.executionKbn === "4"
      ) {
        buttonName = "手続きへ";
      } else {
        buttonName = "手続きへ";
      }
      break;

    case HandleStatus["不要"]:
      buttonName = "戻す";
      break;

    case HandleStatus["完了"]:
      if (isHistory && item.applyId && item.businessType !== "JOB-45") {
        buttonName = "確認";
      }
      break;

    case HandleStatus["取下"]:
      if (isHistory) {
        buttonName = "確認";
      }
      break;

    case HandleStatus["削除"]:
      buttonName = null;
      break;

    case HandleStatus["差戻し"]:
      buttonName = "確認";
      break;
  }

  const handleClick = (name: any) => {
    onClick && onClick(name);
  };

  return buttonName ? (
    <Box className="SCRC020001Components">
      <Box className="buttonGroup">
        {buttonName.split(",").map((item, index) => (
          <TkButton key={index} onClick={() => handleClick(item)}>
            {item}
          </TkButton>
        ))}
      </Box>
    </Box>
  ) : (
    <></>
  );
};

/**
 * 手続きお知らせモーダル
 * @param {any} props.item レスポンスデータ
 * @param {boolean} props.open true:開く false:閉じる
 * @param {any} props.button 対応ボタン
 * @param {any} props.onClose 「閉じる」ボタン押下時のイベント
 * @return ProcedureModal
 */
const ProcedureModal = (props: any) => {
  const { item, button, open, onClose } = props;

  const tableList: ITkFakeTableLineProps[] = [
    {
      title: "対応期日",
      keyword: "dueDate",
      type: "text",
      text: item?.dueDate,
    },
    {
      title: "関連手続き",
      keyword: "procedure",
      type: "text",
      text: TkGetCode(ProcedureName, item?.procedureName),
    },
  ];

  const bodyList = [
    [
      {
        children: (
          <Typography sx={{ whiteSpace: "pre-line" }}>
            {item?.taskDetail}
          </Typography>
        ),
      },
    ],
  ];

  return (
    <TkModal className="SCRC020001Components" open={open}>
      <Box className="modal">
        <TkTitle>{item?.procedureTitle}</TkTitle>
        <TkFakeTable list={tableList} ruleSchema={{}} showButton={false} />

        <TkTable headList={[{ headTitle: "依頼内容" }]} bodyList={bodyList} />

        <Box className="button">
          <TkButton onClick={onClose}>閉じる</TkButton>
          {button}
        </Box>
      </Box>
    </TkModal>
  );
};

export { TopInfo, HandleButton, ProcedureModal };
